export const Mimes = Object.freeze({
  text: 'text/plain',
  binary: 'application/octet-stream',
  unknown: 'application/unknown',
  markdown: 'text/markdown',
  latex: 'text/latex',
  uriList: 'text/uri-list'
});